module.exports = __webpack_public_path__ + "img/picture.89d88a6b.png";